<script>
    import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "sveltestrap";
    import {createEventDispatcher} from "svelte";
    import {writable} from "svelte/store";
    import Help from "../snippets/Help.svelte";
    import ButtonLine from "../snippets/ButtonLine.svelte";

    const dispatch = createEventDispatcher();
    const toggle = () => ($showConfirm = !$showConfirm);
    export let showConfirm = writable(false);
    export let header = 'Sicherheitsabfrage';
    export let confirmLabel = 'OK';
    export let cancelLabel = null;
    export let helpUrl = null;

    const handleConfirm = () => {
        toggle();
        dispatch("confirm", true);
    };

    const handleCancel = () => {
        toggle();
        dispatch("cancel", false);
    };

    function defaultClosing() {
        if (cancelLabel) {
            handleCancel();
        } else {
            handleConfirm();
        }
    }
</script>

<Modal 
    {...$$restProps} 
    backdrop="static" 
    bind:isOpen={$showConfirm} 
    toggle={defaultClosing}
    on:open = {() => jQuery('.modal:last .confirm-button').focus()}
>
    <ModalHeader toggle={defaultClosing}>
        <slot name="header">{header}</slot>
    </ModalHeader>

    <ModalBody>
        <slot />
    </ModalBody>

    <ModalFooter>
        <ButtonLine>
            <Help slot="left" url={helpUrl} />

            {#if cancelLabel}
                <Button on:click={handleCancel} color="primary" data-test-name="cancel">
                    {cancelLabel}
                </Button>
            {/if}

            <Button class="confirm-button" default on:click={handleConfirm} color="primary" data-test-name="confirm">
                {confirmLabel}
            </Button>
        </ButtonLine>
    </ModalFooter>
</Modal>